module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_3_Shakeshaft@2x.9b620dba72781c9846ebcaebd6bd71b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_3_Shakeshaft@2x.png
// module id = 750
// module chunks = 0